import { adminV2Sweepstake } from "@api/all";
import { Button, SWRDataTable } from "@bleu.builders/ui";
import { DownloadButton } from "@components/DownloadButton";
import { PermissionRequiredContent } from "@components/WithAccessControl";
import { useFormActionToast } from "@hooks/useFormActionToast";
import { useQueryAppendedUrl } from "@hooks/useQueryAppendedUrl";
import { useSendActionData } from "@hooks/useSendActionData";
import React, { useState } from "react";
import { json, useActionData, useParams } from "react-router-dom";

const intents = {
  set_winners: adminV2Sweepstake.setWinners,
  generate_entries: adminV2Sweepstake.generateSweepstakeEntries,
};

const intentToastTitle = {
  set_winners: "Winner assigned",
  generate_entries: "Entries generated",
};

const action = async ({ request }) => {
  const body = await request.json();

  if (!intents[body.intent]) {
    return json({
      success: false,
      message: "Invalid intent",
    });
  }

  const data = await intents[body.intent]({ data: { ...body.data } });
  location.reload();

  if (data?.data?.length === 0) {
    return json({
      success: false,
      message: "Failed to perform action",
    });
  }

  return json({
    data,
    intent: body.intent,
    success: true,
  });
};

function SweepstakesUserTable() {
  const { reward_id } = useParams();
  const [selectedData, setSelectedData] = useState([]);
  const actionData = useActionData();
  const { submitWithIntent } = useSendActionData();

  useFormActionToast(actionData, intentToastTitle);

  function SweepstakeActions({ rewardId }: { rewardId: string }) {
    const downloadUrl = useQueryAppendedUrl(
      `/admin/v2/rewards/${rewardId}/sweepstake.csv`,
    );

    const winnersSubmission = async () => {
      await submitWithIntent("set_winners", { selectedData, id: reward_id });
    };

    const generateSweepstakeEntries = async () => {
      await submitWithIntent("generate_entries", { id: reward_id });
    };
    return (
      <div className="flex items-center gap-x-2">
        <Button onClick={generateSweepstakeEntries} variant="outline" size="sm">
          Generate entries
        </Button>
        <Button onClick={winnersSubmission} size="sm">
          Assign Winners
        </Button>
        <DownloadButton url={downloadUrl} text="Export Table" />
      </div>
    );
  }

  return (
    <SWRDataTable
      fetchPath={`/admin/v2/rewards/${reward_id}/sweepstake`}
      action={
        <PermissionRequiredContent resource="rewards" action="manage">
          <SweepstakeActions rewardId={reward_id} />
        </PermissionRequiredContent>
      }
      // @ts-ignore - selectedRow is any
      selectedRows={selectedData}
      // @ts-ignore - setSelectedData receives any
      setSelectedData={setSelectedData}
      defaultParams={{
        columnVisibility: {
          rewards: false,
          gender: false,
        },
      }}
    />
  );
}

SweepstakesUserTable.action = action;
export default SweepstakesUserTable;
